import {  Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Select, Store } from '@ngxs/store';
import {
    AccountActions,
    AccountSelectors,
    ModulesSelectors,
    SosLoaderService,
} from '@serviceos-ng/core';
import { Observable, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';

export interface BirthdayForm {
    title: string;
    edit_button_title: string;
    cancel_button_title: string;
    edit_form: {
        birth_date_input_label: string;
        birth_date_input_error: string;
        confirm_button_title: string;
    };
}

@Component({
    selector: 'serviceos-web-birthdate-form',
    templateUrl: './birthdate-form.component.html',
    styleUrls: ['./birthdate-form.component.scss'],
})
export class BirthdateFormComponent implements OnInit {
    public birthdateForm: FormGroup;
    public subscriptions: Subscription[] = [];
    public birthdateFormExpand = false;

    @Select(AccountSelectors.birthdate)
    public birthdate$!: Observable<string>;
    public birthdate = '';
    public showLoader = false;
    public formErrorMessage = '';
    public hasBirthdate = true;

    @Select(
        ModulesSelectors.getComponentFromModule(
            'account',
            'account_settings_screen.account_details.birthday'
        )
    )
    birthdayForm$!: Observable<BirthdayForm | null>;

    constructor(
		private _fb: FormBuilder,
        private store: Store,
    ) {
        this.birthdateForm = this._fb.group({
            birthdate: ['', [Validators.required, Validators.minLength(10)]],
        });
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.birthdate$.subscribe((birthdate) => {
                
                this.birthdateFormExpand = birthdate ? false : true;
                this.hasBirthdate = birthdate ? true : false;
                
                this.birthdate = birthdate;

                if (this.birthdateFormExpand) {
                    // Fill edit address form
                    this.birthdateForm.patchValue({
                        birthdate: birthdate,
                    });
                }
            })
        );
    }

    public async formSubmit() {
		if (this.birthdateForm.valid) {
            this.showLoader = true;

            this.store
                .dispatch(
                    new AccountActions.updateBirthdate(
                        this.birthdateForm.value.birthdate
                    )
                )
                .pipe(
                    finalize(() => {
                        this.showLoader = false;
                    })
                )
                .subscribe(
                    (res) => {
                        this.formErrorMessage = '';

                        
                        this.birthdateForm.patchValue({
                            birthdate: '',
                        });

                        this.birthdateFormExpand = false;
                    },
                    (error) => {
                        this.formErrorMessage = error?.error[0]?.message;
                    }
                );
        } else {
            const formControlsNames: Array<string> = Object.keys(
                this.birthdateForm.controls
            );

            // Manually trigger reactive form validation
            for (
                let formControlNameIndex = 0;
                formControlNameIndex < formControlsNames.length;
                formControlNameIndex++
            ) {
                const formControlName: string =
                    formControlsNames[formControlNameIndex];

                this.birthdateForm.controls[formControlName].markAsTouched();
                this.birthdateForm.controls[formControlName].markAsDirty();
            }
        }
    }

    /**
     * Toggle form
     */
    toggleForm() {
        this.formErrorMessage = '';

        this.birthdateFormExpand = !this.birthdateFormExpand;

        if (this.birthdateFormExpand) {
            this.birthdateForm.patchValue({
                birthdate: this.birthdate,
            });
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.map((el) => el.unsubscribe());
    }

    get birthdateInput() {
        return this.birthdateForm.get('birthdate');
    }
}
